'use client';
import { track } from '@smartproxy/sp-tracker-js';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { sendGAClickEvent } from '@/components/integrations/trackingScripts';
import { getDataTracker } from '@/components/integrations/trackingScripts/utils';

export function GlobalClickListener() {
  const pathname = usePathname();

  useEffect(() => {
    function handleClick(event: MouseEvent) {
      const target = (event?.target as HTMLElement)?.closest('a, button');

      if (
        !target ||
        (target as HTMLElement).hasAttribute('data-tracker-ignore')
      ) {
        return;
      }

      const trackerId =
        target.getAttribute('[data-tracker]') ||
        getDataTracker(target as HTMLElement) ||
        target.id;

      const eventData = {
        elementType: target.tagName.toLowerCase(), // 'a' or 'button'
        elementText: target.textContent,
        elementId: trackerId,
        href:
          target.tagName.toLowerCase() === 'a'
            ? target.getAttribute('href')
            : null,
        path: window.location.pathname,
      };

      sendGAClickEvent(eventData);
      track(trackerId, eventData);
    }

    document.body.addEventListener('click', handleClick);

    return () => {
      document.body.removeEventListener('click', handleClick);
    };
  }, [pathname]);

  return null;
}
